import Role from './Role'

export enum PermissionEnum {
    NoPermission = 0,
    Read,
    Write,
}

export enum RolePermission {
    ReadArrivalDepartures = 1110,
    UpdateArrivalDepartures = 1120,
    CreateTimetables = 1200,
    ReadTimetables = 1210,
    UpdateTimetables = 1220,
    DeleteTimetables = 1230,
    CreatePassengers = 1300,
    ReadPassengers = 1310,
    ReadAllPassengerTrips = 1315,
    UpdatePassengers = 1320,
    UpdatePassengerGroups = 1321,
    DeletePassengers = 1340,
    CreateBookings = 1400,
    ReadBookings = 1410,
    UpdateBookings = 1420,
    DeleteBookings = 1430,
    CreateTransportationPermissions = 1500,
    ReadTransportationPermissions = 1510,
    UpdateTransportationPermissions = 1520,
    DeleteTransportationPermissions = 1530,
    ReadRideitTokens = 3000,
    WriteRideitTokens = 3010,
}

export class DestinationRole {
    destinationId: number;
    passengerPermission: PermissionEnum;
    timetablePermission: PermissionEnum;
    arrivalsDeparturesPermission: PermissionEnum;
    bookingPermission: PermissionEnum;
    transportationPermission: PermissionEnum;
    schedulePermission: PermissionEnum;
    rideitPermission: PermissionEnum;

    get permissions() {
        const passengerRead = [
            RolePermission.ReadPassengers, 
            RolePermission.ReadAllPassengerTrips, 
            RolePermission.UpdatePassengerGroups,
        ];
        const passengerWrite = [RolePermission.CreatePassengers, RolePermission.UpdatePassengers];
        const passengers = [[], passengerRead, passengerRead.concat(passengerWrite)][this.passengerPermission];

        const timetableRead = [RolePermission.ReadTimetables];
        const timetableWrite = [
            RolePermission.CreateTimetables,
            RolePermission.UpdateTimetables,
            RolePermission.DeleteTimetables,
        ];
        const timetables = [[], timetableRead, timetableRead.concat(timetableWrite)][this.timetablePermission];

        const arrivalRead = [RolePermission.ReadArrivalDepartures];
        const arrivalWrite = [RolePermission.UpdateArrivalDepartures];
        const arrival = [[], arrivalRead, arrivalRead.concat(arrivalWrite)][this.arrivalsDeparturesPermission];

        const bookingRead = [RolePermission.ReadBookings];
        const bookingWrite = [
            RolePermission.CreateBookings,
            RolePermission.UpdateBookings,
            RolePermission.DeleteBookings,
        ];
        const booking = [[], bookingRead, bookingRead.concat(bookingWrite)][this.bookingPermission];

        const transPermRead = [RolePermission.ReadTransportationPermissions];
        const transPermWrite = [
            RolePermission.CreateTransportationPermissions,
            RolePermission.UpdateTransportationPermissions,
            RolePermission.DeleteTransportationPermissions,
        ];
        const transPerm = [[], transPermRead, transPermRead.concat(transPermWrite)][this.transportationPermission];

        const rideitRead = [RolePermission.ReadRideitTokens];
        const rideitWrite = [RolePermission.WriteRideitTokens];
        const rideit = [[], rideitRead, rideitRead.concat(rideitWrite)][this.rideitPermission];

        return passengers.concat(timetables).concat(arrival).concat(booking).concat(transPerm).concat(rideit);
    }

    public static fromApi(apiDestinationRole: any): DestinationRole {
        const destinationRole = new DestinationRole();
        destinationRole.destinationId = apiDestinationRole.destinationId;
        destinationRole.passengerPermission = apiDestinationRole.passengerPermission;
        destinationRole.timetablePermission = apiDestinationRole.timetablePermission;
        destinationRole.arrivalsDeparturesPermission = apiDestinationRole.arrivalsDeparturesPermission;
        destinationRole.bookingPermission = apiDestinationRole.bookingPermission;
        destinationRole.transportationPermission = apiDestinationRole.transportationPermission;
        destinationRole.schedulePermission = apiDestinationRole.schedulePermission;
        destinationRole.rideitPermission = apiDestinationRole.rideitPermission;
        return destinationRole;
    }

    public static newAdminRole(destinationId: number): DestinationRole {
        const destinationRole = new DestinationRole();
        destinationRole.destinationId = destinationId;
        destinationRole.passengerPermission = PermissionEnum.Write;
        destinationRole.timetablePermission = PermissionEnum.Write;
        destinationRole.arrivalsDeparturesPermission = PermissionEnum.Write;
        destinationRole.bookingPermission = PermissionEnum.Write;
        destinationRole.transportationPermission = PermissionEnum.Write;
        destinationRole.schedulePermission = PermissionEnum.Write;

        // Rideit integration requires settings, but the permission can be given to admin users by default, 
        // since it doesn't do anything if the integration isn't enabled.
        destinationRole.rideitPermission = PermissionEnum.Write;
        
        return destinationRole;
    }
}

export default DestinationRole;
